import React, { useId, useRef, useState, useEffect } from 'react';
const ToggleSwitch = ({
  isChecked = false,
  onChange,
  withAdditionalInputLabel = false,
  withAdditionalLabel = false,
  descriptionText = ''
}) => {
  const componentId = useId();
  const componentRef = useRef();
  const [checked, setChecked] = useState(isChecked || false);
  const handleOnChange = () => {
    const currentChecked = !checked;
    if (onChange) {
      onChange(currentChecked);
    }
    setChecked(currentChecked);
  };
  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  const divUniqueId = `div-${componentId}`;
  const spanUniqueId = `span-${componentId}`;
  const inputUniqueId = `input-${componentId}`;
  const dataOnLabel = withAdditionalInputLabel ? 'on' : null;
  const dataOffLabel = withAdditionalInputLabel ? 'off' : null;
  const ariaLabelledBy = withAdditionalLabel ? spanUniqueId : null;
  return /*#__PURE__*/React.createElement("div", {
    id: divUniqueId,
    ref: componentRef,
    className: "ebds-toggleswitch"
  }, withAdditionalLabel ? /*#__PURE__*/React.createElement("span", {
    id: spanUniqueId,
    className: "ebds-toggleswitch__description"
  }, descriptionText) : null, /*#__PURE__*/React.createElement("label", {
    htmlFor: inputUniqueId,
    className: "ebds-toggleswitch__label"
  }, /*#__PURE__*/React.createElement("input", {
    id: inputUniqueId,
    type: "checkbox",
    role: "switch",
    "data-on": dataOnLabel,
    "data-off": dataOffLabel,
    checked: checked,
    onChange: handleOnChange,
    "aria-checked": checked,
    "aria-labelledby": ariaLabelledBy
  })));
};
export default ToggleSwitch;